import PropTypes from 'prop-types';

import {
  DialogActionsStyled,
  ContainerGridStyled
} from '#client/components/Grid/ActionButtonsGrid.style';
import { FocusGrid } from '#client/components/Grid/FocusGrid.style';

import { ButtonWrapper } from './ButtonWrapper';

import { ACTION_BUTTON_TYPE } from './constants';

const ActionButtonsGrid = ({ children, type = ACTION_BUTTON_TYPE.PRIMARY, sx }) => (
  <DialogActionsStyled sx={sx}>
    <ContainerGridStyled>
      <FocusGrid>
        <ButtonWrapper type={type}>{children}</ButtonWrapper>
      </FocusGrid>
    </ContainerGridStyled>
  </DialogActionsStyled>
);

ActionButtonsGrid.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf([...Object.values(ACTION_BUTTON_TYPE)]),
  sx: PropTypes.shape({})
};

export default ActionButtonsGrid;
